import React, { createContext, useState, useEffect, useContext } from 'react'
import initializeWebSocketInstance from '../../../utils/webSocketUtils'
import { useUrlWebSocket } from '../../../redux/zustand/webSocketUrl'

const WebSocketContext = createContext(null)

export const WebSocketProvider = ({ apiUrlSocket, children }) => {
    const [webSocketInstance, setWebSocketInstance] = useState(null)
    const { urlWebSocket } = useUrlWebSocket()

    useEffect(() => {
        const connectToWebSocket = async () => {
            if (!urlWebSocket) return
            const instance = await initializeWebSocketInstance(urlWebSocket)
            setWebSocketInstance(instance)
        }

        connectToWebSocket()
    }, [urlWebSocket])

    return <WebSocketContext.Provider value={webSocketInstance}>{children}</WebSocketContext.Provider>
}

export const useWebSocket = () => useContext(WebSocketContext)
